var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',{attrs:{"size":"s","boxed":""}},[_c('div',[_c('Spacer',{staticClass:"t-center typo--l",attrs:{"y":"l"}},[_vm._v(" "+_vm._s(_vm.$labels.create_accunt)+" ")]),_c('Form',{staticClass:"form--single",attrs:{"id":"register"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }